/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { twoFactorCellverification } from '../fn/two-factor/two-factor-cellverification';
import { TwoFactorCellverification$Params } from '../fn/two-factor/two-factor-cellverification';
import { twoFactorTokenverification } from '../fn/two-factor/two-factor-tokenverification';
import { TwoFactorTokenverification$Params } from '../fn/two-factor/two-factor-tokenverification';

@Injectable({ providedIn: 'root' })
export class TwoFactorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `twoFactorCellverification()` */
  static readonly TwoFactorCellverificationPath = '/2factor/cellverification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `twoFactorCellverification()` instead.
   *
   * This method doesn't expect any request body.
   */
  twoFactorCellverification$Response(params?: TwoFactorCellverification$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return twoFactorCellverification(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `twoFactorCellverification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  twoFactorCellverification(params?: TwoFactorCellverification$Params, context?: HttpContext): Observable<string> {
    return this.twoFactorCellverification$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `twoFactorTokenverification()` */
  static readonly TwoFactorTokenverificationPath = '/2factor/tokenVerification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `twoFactorTokenverification()` instead.
   *
   * This method doesn't expect any request body.
   */
  twoFactorTokenverification$Response(params?: TwoFactorTokenverification$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return twoFactorTokenverification(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `twoFactorTokenverification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  twoFactorTokenverification(params?: TwoFactorTokenverification$Params, context?: HttpContext): Observable<string> {
    return this.twoFactorTokenverification$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
